<template>
  <div class="common-chip cursor-pointer q-mb-sm q-mr-sm"
       :class="{'common-chip--filled': active}" @click="toggleFilter">
    {{ label }}
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    }
  },
  emits: ['filter'],
  data() {
    return {
      active: false
    }
  },
  methods: {
    toggleFilter() {
      this.active = !this.active

      this.$emit('filter', this.label)
    }
  }
}
</script>